<template>
  <div>
    <v-md-date-range-picker
      :showActivatorLabel="false"
      :locale="locale"
      :start-date="dates[0]"
      :end-date="dates[1]"
      :max-date="today"
      opens="right"
      @change="handleChange"
    >
    </v-md-date-range-picker>
  </div>
</template>
<style lang="scss">
.mdrp__activator {
  cursor: pointer;
  background: #ffffff;
  box-shadow: 0px 0px 3px rgba(54, 78, 101, 0.08);
  border-radius: 32px;
  height: 56px;
  .activator-wrapper {
    align-content: space-between;
    .bar {
      display: none !important;
    }
    .text-field {
      cursor: pointer;
      display: inline-block !important;
      border-bottom: none !important;
      font-weight: 500;
      font-size: 13px !important;
      padding: 4px 0 10px 8px !important;
      margin: 14px 0 14px 20px;
      line-height: 20px;
      letter-spacing: 0.02em;
      color: #273852;
      width: 200px !important;
    }
  }
  .activator-wrapper:after {
    content: "\F0ED";
    font-size: 20px;
    font-family: "Material Design Icons";
    float: right;
    line-height: 56px;
    margin-right: 20px;
  }
}
</style>
<style scoped>
div {
  width: 100%;
}
</style>
<script>
import moment from "moment";
export default {
  name: "DateSelect",
  components: {},
  data() {
    return {
      locale: {
        direction: "ltr",
        format: "YYYY-MM-DD/",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ],
        firstDay: 0
      }
    };
  },
  mounted() {},
  methods: {
    handleChange(val) {
      // Не обновлять даты, если они не изменились
      if (
        this.dates[0] == val[0].format("YYYY-MM-DD") &&
        this.dates[1] == val[1].format("YYYY-MM-DD")
      ) {
        return;
      }
      this.dates = [val[0].format("YYYY-MM-DD"), val[1].format("YYYY-MM-DD")];
    }
  },
  computed: {
    today: {
      get() {
        return moment().format("YYYY-MM-DD");
      }
    },
    dates: {
      get() {
        moment.updateLocale("en", { longDateFormat: { L: "D MMM YYYY" } });
        return this.$store.getters["calendar/getDates"];
      },
      set(val) {
        this.$store.commit("calendar/setDates", val);
      }
    },
    dateRangeText() {
      return this.dates
        .map(el => {
          const [year, month, day] = el.split("-");
          return `${day}/${month}/${year}`;
        })
        .join(" - ");
    }
  }
};
</script>
